import { FunctionComponent, useEffect, useState } from 'react';
import TextInputField from '../../Components/TextInput/TextInputField';
import { FormikProps, useFormik } from 'formik';
import { ISpecialDayList } from './IPricing';
import * as Yup from 'yup';
import {
  addSlot,
  clearAddSlotState,
} from '../../Redux/Slicers/Slot/AddSlotSlicer';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import {
  clearUpdateSlotState,
  updateSlot,
} from '../../Redux/Slicers/Slot/UpdateSlotSlicer';
import { useLocation } from 'react-router-dom';
import DatePickers from '../../Components/DatePicker/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import { AutocompleteOption } from '../../Components/Select/ISelectProps';
import Select from '../../Components/Select/Select';
import { addSpecialDay } from '../../Redux/Slicers/SpecialDay/AddSpecialDaySlicer';
import { updateSpecialDay } from '../../Redux/Slicers/SpecialDay/UpdateSpecialDaySlicer';

interface SpecialDayFormProps {
  rows: any;
  masterForm: (data: FormikProps<any>) => void;
}

const SpecialDayForm: FunctionComponent<SpecialDayFormProps> = (props) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null); // State for managing date value

  const { data: updateableDate, updateableDates } = useAppSelector(
    (state) => state.UpdateSpecialDay
  );
  const { pathname } = location;
  const pathnameParts = location.pathname.split('/');
  const id = pathnameParts[pathnameParts.length - 1];
  const { data: getdata } = useAppSelector((state) => state?.Pricing);

  const masterFrom = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      name: Yup.string().required('Please enter a valid name'),
      date: Yup.string().required('Please select a date'),
      // price_structure: Yup.string().required('Please select a Price Structure'),
    }),
    onSubmit: (value) => {
      if (updateableDates && Object.keys(updateableDates).length !== 0) {
        const formattedValue = {
          ...value,
          location_id: id,
          date: dayjs(value.date).format('YYYY-MM-DD'), // Keep local date without UTC conversion
        };
        console.log(formattedValue);
        dispatch(
          updateSpecialDay({ ...formattedValue, id: updateableDates._id })
        );
      } else {
        const formattedValue = {
          ...value,
          location_id: id,
          date: dayjs(value.date).format('YYYY-MM-DD'), // Keep local date without UTC conversion
        };
        dispatch(addSpecialDay(formattedValue));
      }
    },
  });

  useEffect(() => {
    props.masterForm(masterFrom);

    if (updateableDates) {
      masterFrom.setFieldValue('name', updateableDates.name);
      masterFrom.setFieldValue('location_id', id);

      if (updateableDates.date) {
        const formattedDate = dayjs(updateableDates.date).format('YYYY-MM-DD');
        setSelectedDate(dayjs(formattedDate));
        masterFrom.setFieldValue('date', formattedDate); // Set date in 'YYYY-MM-DD' format
      }
      if (updateableDates.price_structure) {
        const priceStructureValue = {
          label: updateableDates.price_structure.name,
          value: updateableDates.price_structure._id,
        };
        masterFrom.setFieldValue('price_structure', priceStructureValue.value);
      }
    }
    return () => {
      dispatch(clearAddSlotState());
      dispatch(clearUpdateSlotState());
      masterFrom.resetForm();
      setSelectedDate(null);
    };
  }, [updateableDates]);

  const data1 = getdata?.response?.data;
  if (!data1) {
    console.log('data not found');
  }

  const projects = Array.isArray(data1)
    ? data1.map((project) => ({
        label: project.name,
        value: project._id!,
      }))
    : [];
  console.log('up', updateableDates);

  return (
    <form
      className="Slot_form"
      onSubmit={masterFrom.handleSubmit}
      onReset={masterFrom.handleReset}
      autoComplete="off">
      <TextInputField
        id="name"
        name="name"
        label="Name"
        value={masterFrom.values.name}
        onChange={masterFrom.handleChange}
        onBlur={masterFrom.handleBlur}
        helperText={masterFrom.touched.name && masterFrom.errors.name}
        error={masterFrom.touched.name && Boolean(masterFrom.errors.name)}
      />

      <DatePickers
        label="Choose Date"
        format="YYYY-MM-DD"
        value={selectedDate || null}
        onChange={(val: any) => {
          if (val) {
            setSelectedDate(val);
            masterFrom.setFieldValue('date', val.format('YYYY-MM-DD')); // Update Formik field value
          } else {
            setSelectedDate(null);
            masterFrom.setFieldValue('date', ''); // Clear Formik field value if date is null
          }
        }}
      />
      <Select
        id="price_structure"
        name="price_structure"
        label="Price Structure"
        value={
          masterFrom.values.price_structure
            ? projects.find(
                (project) => project.value === masterFrom.values.price_structure
              )
            : null
        }
        options={projects}
        onChange={(_, value) => {
          const projectValue = value as AutocompleteOption;
          masterFrom.setFieldValue('price_structure', projectValue?.value);
        }}
        onBlur={masterFrom.handleBlur}
        placeholder="-select-"
      />
      {/* <Select
        id="price_structure"
        name="price_structure"
        label="Price Structure "
        // disabled={
        //   spaceupdateableDate && Object.keys(spaceupdateableDate).length != 0
        // }
        // value={projects?.find(
        //   (project) => project.value === vehicleFrom.values._id
        // )}
        value={
          updateableDates && Object.keys(updateableDates).length != 0
            ? {
                label: updateableDates?.price_structure?.name,
                value: updateableDates?.price_structure?._id,
              }
            : projects?.find(
                (project) => project.value === masterFrom.values._id
              )
        }
        options={projects}
        onChange={(_, value) => {
          const projectValue = value as AutocompleteOption;
          masterFrom.setFieldValue('price_structure', projectValue?.value);
        }}
        onBlur={masterFrom.handleBlur}
        // helperText={
        //   masterFrom.touched.parking_type
        //   // &&
        //   // Boolean(masterFrom.errors.parking_type)
        // }
        // error={
        //   masterFrom.touched.parking_type
        //   //  &&
        //   // Boolean(masterFrom.errors.parking_type)
        // }
        // helperText={vehicleFrom.touched._id && vehicleFrom.errors._id}
        // error={vehicleFrom.touched._id && Boolean(vehicleFrom.errors._id)}
        placeholder="-select-"
      /> */}
      <button
        type="submit"
        style={{ display: 'none' }}
      />
    </form>
  );
};

export default SpecialDayForm;

const initialValues = {
  name: '',
  date: '',
} as ISpecialDayList;
